module.exports = __webpack_public_path__ + "img/landing2.9b1388c6.jpg";